import { type TypographyVariant } from '@volvo/vcdk';
import { Typography } from '@volvo/vcdk-react';
import React, { type PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';

import { withComponentErrorBoundary } from '@/components/ComponentErrorBoundary';
import { dates } from '@/utils';

type Props = PropsWithChildren & {
  date: string;
  variant: TypographyVariant;
  type: 'date' | 'short' | 'month' | 'datetime';
  className?: string;
};

const FormatDateTime: React.FC<Props> = ({ date, variant, type, children, className }) => {
  const { i18n } = useTranslation();

  return (
    <Typography variant={variant} className={className}>
      {type === 'date'
        ? dates.formatDate(date, i18n.language)
        : type === 'short'
          ? dates.formatDateShort(date, i18n.language)
          : type === 'month'
            ? dates.formatDateMonth(date, i18n.language)
            : dates.formatDateTime(date, i18n.language)}
      {children}
    </Typography>
  );
};

export default withComponentErrorBoundary(FormatDateTime);
